import Accordion from "../../../Components/Accordion/theme";
import Alert from "../../../Components/Alert/theme";
import Button from "../../../Components/Button/theme";
import Drawer from "../../../Components/Drawer/theme";
import Heading from "../../../Components/Heading/theme";
import Input from "../../../Components/Input/theme";
import Link from "../../../Components/Link/theme";
import Modal from "../../../Components/Modal/theme";
import Tag from "../../../Components/Tag/theme";

export default {
  Accordion,
  Alert,
  Button,
  Drawer,
  Heading,
  Input,
  Link,
  Tag,
  Modal,
};
